import { MedifitError } from '@meddev/fe-shared';

export class MedifitErrorDefinition {
    private static errorsMvip: { [key: string]: MedifitError } = {
        MVIP_CUSTOMER_NAME_NULL: {
            code: 'MVIP_CUSTOMER_NAME_NULL',
            msg: null,
            displayMessage: $localize`Ime je obvezen podatek.`,
        },
        MVIP_CUSTOMER_SURNAME_NULL: {
            code: 'MVIP_CUSTOMER_SURNAME_NULL',
            msg: null,
            displayMessage: $localize`Priimek je obvezen podatek.`,
        },
        MVIP_CUSTOMER_BIRTHDATE_NULL: {
            code: 'MVIP_CUSTOMER_BIRTHDATE_NULL',
            msg: null,
            displayMessage: $localize`Datum rojstva je obvezen podatek.`,
        },
        MVIP_CUSTOM_GENDER_NULL: {
            code: 'MVIP_CUSTOMER_GENDER_NULL',
            msg: null,
            displayMessage: $localize`Spol je obvezen podatek.`,
        },
    };

    private static errorsEarhiv: { [key: string]: MedifitError } = {
        EARHIV_DISABLED_CONTRACTOR: {
            code: 'EARHIV_DISABLED_CONTRACTOR',
            msg: null,
            displayMessage: $localize`Modul eArhiv je onemogočen.`,
        },
        EARHIV_CREATE_PAPER_REQUEST_ERROR: {
            code: 'EARHIV_CREATE_PAPER_REQUEST_ERROR',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju listine v eArhiv.`,
        },
        EARHIV_CREATE_DOCUMENT_REQUEST_ERROR: {
            code: 'EARHIV_CREATE_DOCUMENT_REQUEST_ERROR',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju dokumenta v eArhiv.`,
        },
        EARHIV_CUSTOMER_NOT_FOUND: {
            code: 'EARHIV_CUSTOMER_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Stranka ni najdena.`,
        },
        EARHIV_DOCUMENT_NOT_FOUND: {
            code: 'EARHIV_DOCUMENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Dokument ni najden.`,
        },
        EARHIV_CONTRACTOR_PAPER_NOT_FOUND: {
            code: 'EARHIV_CONTRACTOR_PAPER_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Listina izvajalca ni najdena.`,
        },
        MEDIFIT_DOCUMENT_NOT_FOUND: {
            code: 'MEDIFIT_DOCUMENT_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Dokument ni najden.`,
        },
        FAILED_TO_FETCH_EARHIV_METADATA_TYPES: {
            code: 'FAILED_TO_FETCH_EARHIV_METADATA_TYPES',
            msg: null,
            displayMessage: $localize`Napaka pri shranjevanju dokumenta v eArhiv.`,
        },
        EARHIV_METADATA_TYPE_NOT_FOUND: {
            code: 'EARHIV_METADATA_TYPE_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Tip metapodatka eArhiv ni najden.`,
        },
        USER_NOT_FOUND: {
            code: 'USER_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Uporabnik ni najden.`,
        },
        CONTRACTOR_NOT_FOUND: {
            code: 'CONTRACTOR_NOT_FOUND',
            msg: null,
            displayMessage: $localize`Izvajalec ni najden.`,
        },
    };

    public static errors: { [key: string]: MedifitError } = {
        ...MedifitErrorDefinition.errorsMvip,
        ...MedifitErrorDefinition.errorsEarhiv,
    };
}
